// extracted by mini-css-extract-plugin
module.exports = {"ck1enfc":"ck1enfc"};